import { themr } from '@friendsofreactjs/react-css-themr';

import ProductsList from './ProductsList';

export default themr('ProductsList')(ProductsList);
